/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  FriendsCard,
  Loading,
  PostCard,
  ProfileCard,
} from "../components";
import { deletePost, fetchPosts, getUserInfo, likePost } from "../utils";
import { NoProfile } from "../assets";

const Profile = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { posts } = useSelector((state) => state.posts);

  const [userInfo, setUserInfo] = useState(user);
  const [loading, setLoading] = useState(false);

  const uri = "/posts/get-user-post/" + id;

  const getUser = async () => {
    const res = await getUserInfo(user?.token, id);
    setUserInfo(res);
  };

  const getPosts = async () => {
    await fetchPosts(user.token, dispatch, uri);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    await deletePost(id, user.token);
    await getPosts();
  };

  const handleLikePost = async (uri) => {
    await likePost({ uri, token: user?.token });
    await getPosts();
  };

  useEffect(() => {
    setLoading(true);
    getUser();
    getPosts();
  }, [id]);

  return (
    <div className="w-full px-0 lg:px-10 2xl:px-40 bg-bgColor h-screen overflow-y-auto">
      {/* Cover Section */}
      <div className="relative w-full h-60 md:h-80 lg:h-96">
        <img
          src={userInfo?.coverUrl || NoProfile}
          alt="cover"
          className="w-full h-full object-cover rounded-b-lg"
        />

        {/* Profile Picture overlay */}
        <div className="absolute -bottom-12 left-6 flex items-center gap-4">
          <img
            src={userInfo?.profileUrl || NoProfile}
            alt={userInfo?.firstName}
            className="w-40 h-40 rounded-full border-4 border-white object-cover"
          />
          <div>
            <h2 className="text-2xl font-bold text-ascent-3">
              {userInfo?.firstName} {userInfo?.lastName}
            </h2>
            <p className="text-2xl font-bold text-ascent-3">
              {userInfo?.friends?.length} Friends
            </p>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div className="w-full px-0 bg-bgColor mt-12">
        {/* Mobile Sidebar */}
        <div className="block lg:hidden lg:w-full px-4 mt-4">
          <ProfileCard user={userInfo} />
          <div className="block lg:hidden mt-4">
            <FriendsCard friends={userInfo?.friends} />
          </div>
        </div>

        <div className="w-full flex gap-2 lg:gap-4 pt-5 pb-10 h-full">
          {/* Left Sidebar */}
          <div className="hidden w-1/3 lg:w-1/4 h-full md:flex flex-col gap-6 overflow-y-auto">
            <ProfileCard user={userInfo} />
          </div>

          {/* Posts Section */}
          <div className="flex-1 h-full px-4 flex flex-col gap-6 overflow-y-auto rounded-lg">
            {loading ? (
              <Loading />
            ) : posts?.length > 0 ? (
              posts?.map((post) => (
                <PostCard
                  key={post?._id}
                  post={post}
                  user={user}
                  deletePost={handleDelete}
                  likePost={handleLikePost}
                />
              ))
            ) : (
              <div className="flex w-full h-full items-center justify-center">
                <p className="text-lg text-ascent-2">No Post Available</p>
              </div>
            )}
          </div>

          {/* Right Sidebar */}
          <div className="hidden w-1/4 h-full lg:flex flex-col gap-8 overflow-y-auto">
            <FriendsCard friends={userInfo?.friends} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
